// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host table, :host iframe {
  border-collapse: collapse;
  border: none;
  width: 100%;
  height: 100%;
}

:host iframe {
  border-collapse: collapse;
  border: none;
  width: 100%;
  z-index: 1;
}

:host .body {
  height: 100%;
  width: 100%;
  vertical-align: top;
}
:host td.attachment {
  padding: 3px;
}
:host .attachment div {
  display: inline-block;
  margin-right: 1em;
  line-height: 2;
}
:host a {
  color: #ba68c8;
  cursor: pointer;
}
:host td:first-child {
  color: #222;
}
:host td.text {
  padding: 0;
}
:host td.html {
  padding: 10px 0 0;
}
:host .subject, :host .fit {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 3px;
  box-shadow: inset 0 0 6px rgba(0,0,0,.05);
  padding: 3px 5px;
  white-space: pre-wrap;
}
.body iframe {
  border: 1px solid #f4f5f7;
  border-radius: 3px;
}
:host .fit {
  height: 100%;
  overflow: auto;
  padding: .5em 1em;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer-controller/file-viewer/mail-viewer/mail-viewer.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[":host table, :host iframe {\n  border-collapse: collapse;\n  border: none;\n  width: 100%;\n  height: 100%;\n}\n\n:host iframe {\n  border-collapse: collapse;\n  border: none;\n  width: 100%;\n  z-index: 1;\n}\n\n:host .body {\n  height: 100%;\n  width: 100%;\n  vertical-align: top;\n}\n:host td.attachment {\n  padding: 3px;\n}\n:host .attachment div {\n  display: inline-block;\n  margin-right: 1em;\n  line-height: 2;\n}\n:host a {\n  color: #ba68c8;\n  cursor: pointer;\n}\n:host td:first-child {\n  color: #222;\n}\n:host td.text {\n  padding: 0;\n}\n:host td.html {\n  padding: 10px 0 0;\n}\n:host .subject, :host .fit {\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 3px;\n  box-shadow: inset 0 0 6px rgba(0,0,0,.05);\n  padding: 3px 5px;\n  white-space: pre-wrap;\n}\n.body iframe {\n  border: 1px solid #f4f5f7;\n  border-radius: 3px;\n}\n:host .fit {\n  height: 100%;\n  overflow: auto;\n  padding: .5em 1em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
